import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=3ea7b7ea&scoped=true&"
import script from "./GroupDetails.vue?vue&type=script&lang=js&"
export * from "./GroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=3ea7b7ea&lang=scss&scoped=true&"
import style1 from "./GroupDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea7b7ea",
  null
  
)

export default component.exports